// src/pages/ThankyouPage.jsx
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  Container,
  Row,
  Col,
  Spinner,
  Alert,
  Button,
  Card,
} from "react-bootstrap";
import { auth } from "../utils/firebaseConfig";

const ThankyouPage = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const [status, setStatus] = useState("pending"); // "pending" | "ok" | "error"
  const [message, setMessage] = useState("");

  useEffect(() => {
    const confirmPayment = async () => {
      // 1) Leer ORDER_ID desde la URL (?token=...)
      const params = new URLSearchParams(location.search);
      const orderID = params.get("token"); // PayPal usa 'token' como orderID

      if (!orderID) {
        setStatus("error");
        setMessage("Missing PayPal order ID in URL.");
        return;
      }

      // 2) Verificar que el usuario siga logueado
      const user = auth.currentUser;
      if (!user) {
        setStatus("error");
        setMessage("You must be logged in to complete the payment.");
        return;
      }

      try {
        // 3) Obtener ID token de Firebase
        const idToken = await user.getIdToken();

        // 4) Llamar a tu backend con Authorization: Bearer
        const res = await fetch(
          `${process.env.REACT_APP_API_URL}/api/paypal/capture-order`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${idToken}`,
            },
            body: JSON.stringify({ orderID }),
          }
        );

        const data = await res.json();

        if (!res.ok) {
          console.error("❌ capture-order error:", data);
          setStatus("error");
          setMessage(
            data?.message ||
              data?.error ||
              "There was a problem confirming your payment."
          );
          return;
        }

        // Aquí ya se ejecutó toda la lógica de guardar Subscription + User
        setStatus("ok");
        setMessage("Your payment was completed successfully. Enjoy your plan!");
      } catch (err) {
        console.error("❌ capture-order fetch error:", err);
        setStatus("error");
        setMessage("Unexpected error confirming your payment.");
      }
    };

    confirmPayment();
  }, [location.search]);

  return (
    <Container className="py-5">
      <Row className="justify-content-center">
        <Col xs={12} md={8} lg={6}>
          <Card className="text-center">
            <Card.Body>
              {status === "pending" && (
                <>
                  <Spinner animation="border" />
                  <p className="mt-3 mb-0">
                    Confirming your payment with PayPal...
                  </p>
                </>
              )}

              {status === "ok" && (
                <>
                  <div style={{ fontSize: "3rem" }}>🎉</div>
                  <Card.Title className="mt-3">Thank you!</Card.Title>
                  <Card.Text className="mt-2">{message}</Card.Text>
                  <Card.Text className="text-muted">
                    You now have access to Cratepic resources with your new
                    plan.
                  </Card.Text>
                  <Button
                    className="mt-3"
                    variant="primary"
                    onClick={() => navigate("/user")}
                  >
                    Go to your account
                  </Button>
                </>
              )}

              {status === "error" && (
                <>
                  <Card.Title>Oops… something went wrong</Card.Title>
                  <Alert variant="danger" className="mt-3">
                    {message}
                  </Alert>
                  <Button
                    className="mt-3 me-2"
                    variant="secondary"
                    onClick={() => navigate("/pricing")}
                  >
                    Back to Pricing
                  </Button>
                  <Button
                    className="mt-3"
                    variant="outline-primary"
                    onClick={() => navigate("/")}
                  >
                    Go to Home
                  </Button>
                </>
              )}
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default ThankyouPage;
